import { createContext } from 'react';
import Question from '../../interfaces/question';
import Survey from '../../interfaces/survey';

export interface ObjectId {
  id: number;
}

export interface ValueAnswer {
  question: ObjectId;
  value: string | null;
}

export interface ChoicesAnswer {
  question: ObjectId;
  choices: ObjectId[];
  value?: string | null;
}

export interface ChosenOptionAnswer {
  question: ObjectId;
  chosenOption: ObjectId | null;
}

export type AnswerShape =
  | { value: string | null }
  | { choices: ObjectId[] }
  | { chosenOption: ObjectId | null };

export type MappedAnswer = ValueAnswer | ChoicesAnswer | ChosenOptionAnswer;

interface DefaultValueProps {
  upsertMappedAnswers: (answers: Map<number, MappedAnswer>) => void;
  mappedAnswers: Map<number, MappedAnswer>;
  paginatedSurvey: Map<number, Question[]>;
  surveyPage: number;
  increasePage: () => void;
  survey: Survey | undefined;
}

const defaultValue: DefaultValueProps = {
  upsertMappedAnswers: () => null,
  mappedAnswers: new Map(),
  paginatedSurvey: new Map(),
  surveyPage: 0,
  increasePage: () => null,
  survey: undefined,
};

export const SurveyPageContext = createContext(defaultValue);
